export default __webpack_public_path__ + "static/media/lv7.984d85f6.png";